import { MinimalWrapper } from 'ui-component/wrappers';
import { Stack, Box, Button } from '@mui/material';
import { Outlet } from 'react-router-dom';
import LanguageSection from 'layout/MainLayout/Header/LanguageSection';
import { useSettings } from 'hooks/useSettings';
import { useTranslation } from 'react-i18next';
// ==============================|| MINIMAL LAYOUT ||============================== //

const MinimalLayout = () => {
    const { project_public_enabled, projectLoginBackground } = useSettings();
    const { t } = useTranslation();
    const projectPublicEnabled = project_public_enabled === 'true' || project_public_enabled === true;
    const loginBackgroundStyles = projectLoginBackground
        ? {
              backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.18), rgba(255, 255, 255, 0.18)), url(${projectLoginBackground})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover'
          }
        : undefined;

    const goToPublicSite = () => {
        window.open('/public', '_blank', 'noopener,noreferrer');
    };

    return (
        <MinimalWrapper sx={loginBackgroundStyles}>
            <Stack alignItems="end" sx={{ p: 1 }}>
                <Box sx={{ p: 1, background: 'white', borderRadius: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                    {projectPublicEnabled && (
                        <Button variant="outlined" size="small" onClick={goToPublicSite} sx={{ whiteSpace: 'nowrap' }}>
                            {t('PublicSite', 'Public Site')}
                        </Button>
                    )}
                    <LanguageSection />
                </Box>
                <Outlet />
            </Stack>
        </MinimalWrapper>
    );
};

export default MinimalLayout;
